{
  "version": 1,
  "asset_id": "9a4347e6-496b-44bc-8198-4d70a1473ce7",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/9a4347e6-496b-44bc-8198-4d70a1473ce7/vlmcare-article-header.png",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/9a4347e6-496b-44bc-8198-4d70a1473ce7/vlmcare-article-header.png",
  "original_filename": "vlmcare-article-header.png",
  "size": 1664315,
  "content_type": "image/png",
  "created_at": "2026-06-17T08:14:59Z"
}
